import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import ReferralContent from './components/ReferralContent/ReferralContent'
import VoucherOffer from './components/VoucherOffer/VoucherOffer'
import ThanksFooter from './components/ThanksFooter/ThanksFooter'
import Blurb from './components/Blurb/Blurb'
import Ambassador from './components/Ambassador/Ambassador'
import Downloads from './components/Downloads/Downloads'
import Loader from 'components/UI/Loader/Loader'

import {
  phoneMaxWidth,
  ipadPortraitMaxWidth
} from '../../DashboardSettings.styles'
import { LoaderWrapper } from '../../DashboardSettings.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class Referrals extends Component {
  static propTypes = {
    teachers: PropTypes.array,
    ambassadorSignUp: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
      ambassadorEmailSent: false
    }

    this.sendAmbassadorEmail = this.sendAmbassadorEmail.bind(this)
  }

  sendAmbassadorEmail () {
    this.props.ambassadorSignUp().then(() => {
      this.setState({
        ambassadorEmailSent: true
      })
    })
  }

  render () {
    const {
      teachers = [],
      isSubscribed,
      ambassadorSignUp,
      ambassador,
      loading,
      screenWidth
    } = this.props

    if (loading) {
      return (
        <LoaderWrapper>
          <Loader
            bgColor='rgba(0,0,0,0)'
            itemColor={colors.pink}
            itemSize='90'
          />
        </LoaderWrapper>
      )
    }

    const hasTwoToFiveTeachers =
      isSubscribed && teachers.length > 1 && teachers.length < 6
    const hasMoreThanFiveTeachers = isSubscribed && teachers.length >= 6

    return (
      <Fragment>
        {hasTwoToFiveTeachers ? (
          <Fragment>
            <VoucherOffer
              direction='darkRight'
              sendAmbassadorEmail={this.sendAmbassadorEmail}
              ambassadorEmailSent={this.state.ambassadorEmailSent}
              teachers={teachers}
              ambassador={ambassador}
            />
            {screenWidth > phoneMaxWidth && (
              <Fragment>
                <Blurb direction='darkLeft' />
                <Ambassador
                  direction='darkRight'
                  sendAmbassadorEmail={this.sendAmbassadorEmail}
                  ambassadorEmailSent={this.state.ambassadorEmailSent}
                  ambassador={ambassador}
                  teachers={teachers}
                />
                <Downloads direction='darkLeft' />
              </Fragment>
            )}
          </Fragment>
        ) : (
          <ReferralContent {...this.props} />
        )}
        {hasMoreThanFiveTeachers &&
          screenWidth > phoneMaxWidth && <ThanksFooter />}
      </Fragment>
    )
  }
}
